import {createSlice} from "@reduxjs/toolkit";

export const loginSlice = createSlice({
    name: "token",
    initialState: {
        userTokens: {
            accessToken: null,
            refreshToken: null,
            idToken: null,
        },
        userName: null,
        emailAddress: null,
        loginState: false,
        authStatus: "checking",
        userId: null,
        isPro: false,
        userTier: null,
        storageUsedInBytes: 0,
        hasDataCollectionConsent: null,
        displayId: null,
        isSeatManager: false,
        allocatedStorageGBs: 0,
    },
    reducers: {
        setTokens: (state, action) => {
            state.userTokens = action.payload;
        },
        setUsername: (state, action) => {
            state.userName = action.payload;
        },
        setEmailAddress: (state, action) => {
            state.emailAddress = action.payload;
        },
        setLoginState: (state, action) => {
            state.loginState = action.payload;
            state.authStatus = action.payload ? "authenticated" : "unauthenticated";
        },
        setAuthStatus: (state, action) => {
            state.authStatus = action.payload;
        },
        setUserInfo: (state, action) => {
            state.userId = action.payload.id;
            state.displayId = action.payload.uid;
            state.isPro = action.payload.isPro;
            state.hasDataCollectionConsent = action.payload.hasDataCollectionConsent;
            state.userTier = action.payload.userTier;
            state.storageUsedInBytes = action.payload.storageUsedInBytes;
            state.allocatedStorageGBs = action.payload.allocatedStorageGbs;
            state.isSeatManager = action.payload.isSeatManager;
        },
    },
});

export const {
    setTokens,
    setUsername,
    setEmailAddress,
    setLoginState,
    setAuthStatus,
    setUserInfo,
} = loginSlice.actions;

const selectLoginTokenState = (state) => state.loginToken;

export const selectTokens = (state) => selectLoginTokenState(state).userTokens;
export const selectAccessToken = (state) => selectTokens(state).accessToken;
export const selectRefreshToken = (state) => selectTokens(state).refreshToken;
export const selectIdToken = (state) => selectTokens(state).idToken;
export const selectJWTToken = (state) => selectIdToken(state);
export const selectUsername = (state) => selectLoginTokenState(state).userName;
export const selectEmailAddress = (state) => selectLoginTokenState(state).emailAddress;
export const selectLoginState = (state) => selectLoginTokenState(state).loginState;
export const selectAuthStatus = (state) => selectLoginTokenState(state).authStatus;
export const selectUserId = (state) => selectLoginTokenState(state).userId;
export const selectDisplayId = (state) => selectLoginTokenState(state).displayId;
export const selectUserStorageLimit = (state) => selectLoginTokenState(state).allocatedStorageGBs;

export const selectLoginToken = (state) => selectLoginTokenState(state);

export default loginSlice.reducer;

